import $ from "jquery";

const inspiration = (scroll) => {
        $('.inspiration__library').hide().eq(0).slideDown();

    $('.inspiration__list a').on('click', function (e) {
        e.preventDefault();

        const $this = $(this);
        const $inspirationSection = $this.closest('.inspiration');
        const $inspirationList = $inspirationSection.find('.inspiration__library');
        const index = $this.parent().index();

        if (!$this.hasClass('active')) {
            $inspirationSection.find('.inspiration__list a.active').removeClass('active');
            $this.addClass('active');

            $inspirationList.filter(':visible').slideUp(() => {
                scroll.update();
                
            });
            $inspirationList.eq(index).slideDown(() => {
                scroll.update();
            });
        }
    });
};

export default inspiration;
